/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Active_DescriptionInputs */

const en_agent_authorization_active_description = /** @type {(inputs: Agent_Authorization_Active_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Agent can now obtain its project token and continue. Your listing will be submitted for editorial review automatically.`)
};

const zh_agent_authorization_active_description = /** @type {(inputs: Agent_Authorization_Active_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 现在可以获取项目 token 并继续。你的条目将自动提交，进入编辑审核。`)
};

/**
* | output |
* | --- |
* | "The Agent can now obtain its project token and continue. Your listing will be submitted for editorial review automatically." |
*
* @param {Agent_Authorization_Active_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_active_description = /** @type {((inputs?: Agent_Authorization_Active_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Active_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_active_description(inputs)
	return zh_agent_authorization_active_description(inputs)
});
export { agent_authorization_active_description as "agent.authorization.active_description" }